import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { VolunteerApplication } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';

//#region Volunteer Types
export type VolunteerApplicationRequest = {
  name: string;
  surname: string;
  email: string;
};
//#endregion

@Injectable({
  providedIn: 'root'
})
export class VolunteerService extends ApiService {

  //#region Endpoints
  readonly #VOLUNTEER_APPLICATIONS_ENDPOINT = 'volunteer/applications';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public apply(application: VolunteerApplicationRequest): Observable<any> {
    return this.post(`${this.#VOLUNTEER_APPLICATIONS_ENDPOINT}`, application);
  }

  public getApplications(): Observable<VolunteerApplication[]> {
    return this.get<VolunteerApplication[]>(`${this.#VOLUNTEER_APPLICATIONS_ENDPOINT}`);
  }
  //#endregion
  
}
